import { ThemeOptions } from '@mui/material';

export const buttonThemeOptions: ThemeOptions = {
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          boxShadow: 'none',
          textTransform: 'none',
          whiteSpace: 'nowrap',
        },
        sizeSmall: {
          padding: '4px 10px',
          height: '30px',
          fontSize: '13px',
          lineHeight: '22px',
        },
        sizeMedium: {
          padding: '6px 16px',
          height: '36px',
          fontSize: '14px',
          lineHeight: '24px',
        },
        sizeLarge: {
          padding: '10px 22px',
          height: '46px',
          fontSize: '15px',
          lineHeight: '26px',
        },
      },
    },
  },
};
